<template>
	<!-- Locations -->
	<div
		class="select-location"
        v-if="locations.available.length && locations.available.length > 1"
	>
		<div class="book-time-single-date-xs">
			<div class="row">
				<div class="col-xs-12">
                    <a
                        href="#"
                        @click.prevent="
                            setLocation(location);
                            selectedSlot = false;
                        "
                        class="nk-button nk-button-location"
                        style="margin-right: 10px;"
                        v-for="location in locations.available"
                        :key="'select-location-' + location"
                        :class="{
                            'link-close-right': locations.selected == location &&
                                    locations.selected,
                            'nk-button-gray': locations.selected != location || 
                                    !locations.selected,
                        }"
                    >
                        <a
                            href="#"
                            >{{ formatLocationNameInList(location) }}</a
                        >
                    </a>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";

export default {
	components: {},
	computed: {
		...mapState(["locations", "ui", "activities"]),
		...mapGetters(["formatLocationNameInList"])
	},
	methods: {
		...mapActions(["setLocation"])
	}
};
</script>